import $ from 'jquery';
const mobileBanners = function () {
  var _index = 0;

  $('.image_slide').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    dots: false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          dots: true,
          centerPadding: '0px',
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          dots: true,
          centerPadding: '0px',
        }
      }
    ]

  });

  function loading() {
    $('.image_slide').closest('.banner_wraps').removeClass('loading-image');
  }

  setTimeout(loading, 3000);

  $('#compare_products .product-item').eq(0).addClass('active');
  $('._popup').eq(1).hide();

  $('.holiday-page .btn-box .btn_feature').click(function () {
    var top = $(window).scrollTop();
    if (top > 200) {
      window.scrollTo({ top: 50, behavior: 'smooth' });
    }
    $('.holiday-page #myModal').css('display', 'block');
    $('.holiday-page #myModal .modal-content').css('bottom', '0');
    $('.holiday-page .btn-box').css('display', 'none');
  })

  $(document).on('click', '.close_button', function () {
    $('.holiday-page .btn-box').css('display', 'flex');
    $('.holiday-page #myModal .modal-content').css('bottom', '-550px');
    $('.holiday-page #myModal').css('display', 'none');
  })

  $('.see_compare_btn').click(function (e) {
    e.stopPropagation();
    $('.holiday-page #compare_product_modal').show();
    $('body').css({ 'overflow': 'hidden' });
  })

  $('.product-modal-content').find('.close').click(function () {
    $("#compare_product_modal").hide();
    $('body').css({ 'overflow': 'auto' });
  });

  window.onclick = function (event) {
    var modal = document.getElementById("compare_product_modal");
    if (event.target == modal) {
      $("#compare_product_modal").hide();
      $('body').css({ 'overflow': 'auto' });
    }
  }

  $('.banner_wraps .slick-dots li').mouseover(function () {
    var index = $(this).text() - 1;
    var variant_id = $(`.options_slickdots.active`).find(`.product-option__color:nth("${index}")`).data('variant-id');
    var product_id = $(this).closest('.hero_images').find('.banner-product').eq(_index).data('product-id');
    $(`._popup[data-product-id="${product_id}"]`).find('.product_variant').attr('data-variant-id', variant_id);
    $(`._popup[data-product-id="${product_id}"]`).find('.product-options__list .product-option').eq(index).find('.product-option__color').addClass('checked');
    $(`.holiday[data-product-id="${product_id}"]`).find('.product-options__list .product-option').eq(index).find('[data-quick-atc-swatch]').click();
  })

  $('.hero_images').on('beforeChange', function (event, slick, currentSlide, index) {
    var variant_id = $(`.options_slickdots.active`).find(`.product-option__color:nth("${index}")`).data('variant-id');
    var product_id = $(this).closest('.hero_images').find('.banner-product').eq(_index).data('product-id');
    $(`.options_slickdots:nth("${_index}") .product-option__color, ._popup:nth("${_index}") .product-option__color`).removeClass('checked');
    $(`.options_slickdots:nth("${_index}") .product-option`).eq(index).find('.product-option__color').addClass('checked');
    $(`._popup[data-product-id="${product_id}"]`).find('.product_variant').attr('data-variant-id', variant_id);
    $(`._popup[data-product-id="${product_id}"]`).find('.product-options__list .product-option').eq(index).find('.product-option__color').addClass('checked');
    $(`.holiday[data-product-id="${product_id}"]`).find('.product-options__list .product-option').eq(index).find('[data-quick-atc-swatch]').click();
  });

  $('._popup .product-option__color').mouseover(function () {
    var index = $(this).data('num');
    var variant_id = $(this).data('variant-id');
    var product_id = $(this).closest('._popup').data('product-id');
    var scrollTop = window.pageYOffset;
    var scrollLeft = window.pageXOffset;
    console.log(_index);
    $(this).closest('._popup').find('.product_variant').attr('data-variant-id', variant_id);
    $(`.banner-product[data-product-id="${product_id}"]`).find(`.slick-dots li`).eq(index).find('button').click();
    window.scrollTo(scrollLeft, scrollTop);
  })


  $('#compare_products .product-item').mouseover(function () {
    var index = $(this).data('number');
    _index = index;
    var product_id = $(this).find('[data-product-id]').data('product-id');
    $('#compare_products .product-item').removeClass('active');
    $(this).addClass('active');
    $('._popup').css('display', 'none');
    $(`._popup[data-product-id="${product_id}"]`).css('display', 'flex');
    $('.banner_wraps').removeClass('active');
    $(`.banner-product[data-product-id="${product_id}"]`).find('.banner_wraps').addClass('active');
    $('.options_slickdots').removeClass('active')
    $('.options_slickdots').eq(index).addClass('active');
    $('.banner_wraps.active .image_slide').slick('refresh');
  })

  var stickyHeight = $('.js-sticky-cart').eq(0).outerHeight() || 0;

  $(window).scroll(function () {
    const $stickyCart = $('.js-sticky-cart');

    if ($stickyCart.length < 1) return;

    var scrollBottom = $(window).scrollTop() + $(window).height();
    var stickyBottom = $stickyCart.eq(0).offset().top + stickyHeight;
    
    if (scrollBottom > stickyBottom) {
      $('._popup').attr('style', 'display: flex;position: fixed;');
      var alt = !(_index);
      $('._popup').eq(alt).attr('style', 'display: none;position: fixed;');
      $('.site-footer .container').attr('style', 'padding-bottom:' + $('.product_item ._popup').outerHeight() + 'px');
    }
    else {
      $('._popup').attr('style', 'display: none;');
      $('._popup').eq(_index).attr('style', 'display: flex;position: static;');
      $('.site-footer .container').attr('style', 'padding-bottom:0');
    }
  })
}

export default mobileBanners;
